import React from "react";
import { Link } from "react-router-dom";
import IMAGE_URL from "../../assets/images/appImages/FOUTA BIO AHMAD SITE.png";

const ApprocheSection: React.FC = () => {
  return (
    <section className="approche-section py-5">
      <div className="container">
        <div className="row align-items-center gy-5">
          {/* Colonne texte */}
          <div className="col-lg-6">
            <p className="approche-eyebrow mb-3">NOTRE APPROCHE</p>

            <h2 className="approche-title mb-4">
              Une approche qui commence par l'écoute
            </h2>

            <p className="approche-text mb-4">
              Avant de tirer une conclusion, nous prenons le temps de
              comprendre votre situation. Notre approche considère la santé
              physique, les habitudes de vie, le sommeil, l'alimentation,
              l'état émotionnel, l'environnement relationnel et, lorsque cela
              est pertinent, la dimension spirituelle.
            </p>

            <blockquote className="approche-quote mb-4">
              « Avant de conclure, regardons l'ensemble. »
            </blockquote>


            <Link to="/accompagnements" className="approche-link">
            Découvrir notre approche <span aria-hidden="true">→</span>
            </Link>
          </div>

          {/* Colonne image */}
          <div className="col-lg-6">
            <div className="approche-image-wrapper">
              <img
                src={IMAGE_URL}
                alt="Ahmad BA, spécialiste en médecine prophétique"
                className="approche-image img-fluid"
              />

              <div className="approche-badge">
                <p className="approche-badge-name mb-1">AHMAD BA</p>
                <p className="approche-badge-title mb-0">
                  Spécialiste en médecine prophétique
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApprocheSection;